export type SystemControlAction =
  | "pause_worker_jobs"
  | "resume_worker_jobs"
  | "disable_bot_commands"
  | "enable_bot_commands"
  | "lock_garage_operations"
  | "unlock_garage_operations"
  | "pause_corpse_drops"
  | "resume_corpse_drops"
  | "enable_corpse_store"
  | "disable_corpse_store"
  | "pause_store_purchases"
  | "resume_store_purchases"
  | "pause_gambling"
  | "resume_gambling";

export interface PortalActionContext {
  userId: string;
  roleIds: string[];
  serverId: string;
}

export function buildGarageParkPayload(context: PortalActionContext): { userId: string; actorDiscordRoleIds: string[] } {
  return {
    userId: context.userId,
    actorDiscordRoleIds: context.roleIds
  };
}

export function buildGarageRedeemPayload(
  context: PortalActionContext,
  garageDinoId: string
): { userId: string; garageDinoId: string; serverId: string } {
  return {
    userId: context.userId,
    garageDinoId,
    serverId: context.serverId
  };
}

export function buildSystemControlPayload(
  context: PortalActionContext,
  action: SystemControlAction,
  reason: string
): { action: SystemControlAction; actorUserId: string; actorDiscordRoleIds: string[]; reason: string } {
  return {
    action,
    actorUserId: context.userId,
    actorDiscordRoleIds: context.roleIds,
    reason
  };
}
